var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"orederlist"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:_vm.actived == item.orderType ? 'selected' : '',on:{"click":function($event){return _vm.getorder(item.orderType)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }